<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item :to="{ path: '/home' }">首页</el-breadcrumb-item>
      <el-breadcrumb-item>内部管理</el-breadcrumb-item>
      <el-breadcrumb-item>生产管理</el-breadcrumb-item>
      <el-breadcrumb-item>Bom</el-breadcrumb-item>
    </el-breadcrumb>

    <!-- Tabs -->
    <el-tabs v-model="activeName" type="border-card">
      <!-- 清单列表 strat -->
      <el-tab-pane label="清单列表" name="first">
        <!-- 查询 start -->
        <el-form :inline="true" :model="keywords" ref="keywordsRef" label-width="82px">
          <el-form-item label="">
            <el-select v-model="keywords.parentid" placeholder="请选择项目" class="select" style="width: 150px;">
              <el-option label="请选择项目" value="0"></el-option>
              <el-option
                v-for="item in parentlist" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.name" @keyup.enter.native="clicksearch" placeholder="请输入材料名称" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item label="">
            <el-input v-model="keywords.bomsn" @keyup.enter.native="clicksearch" placeholder="请输入材料编号" style="width: 150px;"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="clicksearch">查询</el-button>
            <el-button type="success" @click="clickexcel()">导出</el-button>
            <el-button type="success" @click="clickmuban" v-if="SubRule_MadeManagement_AddProjectbom" plain>点击下载批量导入模板</el-button>
            <TencentyunCosUploadExcel @change="changeTencentyunCosUploadExcel" v-if="SubRule_MadeManagement_AddProjectbom"></TencentyunCosUploadExcel>
          </el-form-item>
          <p v-if="SubRule_MadeManagement_AmountProjectbom">材料成本小计：{{Totalamount}}</p>
        </el-form>
        <!-- 查询 end -->

        <el-table :data="dataList" border stripe >
          <el-table-column prop="Id" label="编号" header-align="center" align="center" min-width="3%"></el-table-column>
          <el-table-column prop="Bomsn" label="材料编号" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Name" label="材料名称" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Specifications" label="规格型号" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Num" label="数量" header-align="center" align="center" min-width="7%"></el-table-column>
          <el-table-column prop="Price" label="单价（未税）" header-align="center" align="center" min-width="7%" v-if="SubRule_MadeManagement_AmountProjectbom"></el-table-column>
          <el-table-column prop="Amount" label="金额" header-align="center" align="center" min-width="7%" v-if="SubRule_MadeManagement_AmountProjectbom"></el-table-column>
          <el-table-column prop="Createtime" label="创建时间" header-align="center" align="center" min-width="10%"></el-table-column>
          <el-table-column label="操作" header-align="center" align="center" min-width="8%">
            <template v-slot="scope">
              <el-button v-if="SubRule_MadeManagement_DelProjectbom && scope.row.Bomtype == 3" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickdelete(scope.row)">删除</el-button>
              <el-button v-if="SubRule_MadeManagement_EditProjectbom && scope.row.Bomtype == 3" type="text" size="mini" style="margin-left: 0; margin-right: 5px" @click="clickedit(scope.row)">修改</el-button>
            </template>
          </el-table-column>
        </el-table>

        <!-- 分页 -->
        <div class="pages">
          <el-pagination
            @current-change="handleCurrentPageChange"
            :page-size="10"
            layout="total, prev, pager, next, jumper"
            :total="dataListnum"
			:current-page.sync="selectedPageNo">
          </el-pagination>
        </div>
      </el-tab-pane>
      <!-- 清单列表 end -->

      <!-- 添加 start -->
      <el-tab-pane label="添加" v-if="SubRule_MadeManagement_AddProjectbom">
        <el-form :model="addData" ref="addDataRef" label-width="180px">
          <el-form-item label="">
            <label slot="label">
              <span style="color: #FF0000;">项目(必选)</span>
            </label>
            <el-select v-model="addData.parentid" placeholder="请选择项目" class="select" style="width: 150px;">
              <el-option
                v-for="item in parentlist" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材料编号" class="addAdminForm">
            <el-input v-model="addData.bomsn" placeholder="请输入材料编号"></el-input>
          </el-form-item>
          <el-form-item label="材料名称" class="addAdminForm">
            <el-input v-model="addData.name" placeholder="请输入材料名称"></el-input>
          </el-form-item>
          <el-form-item label="规格型号" class="addAdminForm">
            <el-input v-model="addData.specifications" placeholder="请输入规格型号"></el-input>
          </el-form-item>
          <el-form-item label="数量" class="addAdminForm">
            <el-input v-model="addData.num" placeholder="请输入数量"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickadd">添加</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加 end -->

      <!-- 添加主类别 start -->
      <el-tab-pane label="添加主类别" v-if="SubRule_MadeManagement_AddProjectbomMain">
        <el-form :model="addDataMain" ref="addDataMainRef" label-width="180px">
          <el-form-item label="所属机构" class="addAdminForm">
            <RsljigouInternal :propsjigouid="addDataMain.jigouid" :propsjigouname="addDataMain.jigouname" @change="changeRsljigouInternal"></RsljigouInternal>
          </el-form-item>
          <el-form-item label="" class="addAdminForm">
            <label slot="label">
              <span style="color: #FF0000;">收款账户(必选)</span>
            </label>
            <el-select v-model="addDataMain.paymentaccountid" placeholder="请选择收款账户" style="width: 260px;">
              <el-option
                v-for="item in PaymentAccountList" :key="item.Id" :label="item.Accountname" :value="item.Id">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="材料编号" class="addAdminForm">
            <el-input v-model="addDataMain.bomsn" placeholder="请输入材料编号"></el-input>
          </el-form-item>
          <el-form-item label="材料名称" class="addAdminForm">
            <el-input v-model="addDataMain.name" placeholder="请输入材料名称"></el-input>
          </el-form-item>
          <el-form-item label="规格型号" class="addAdminForm">
            <el-input v-model="addDataMain.specifications" placeholder="请输入规格型号"></el-input>
          </el-form-item>
          <el-form-item class="mt20">
            <el-button type="primary" @click="clickaddmain">添加主类别</el-button>
            <el-button type="info" @click="clickreturn">返回</el-button>
          </el-form-item>
        </el-form>
      </el-tab-pane>
      <!-- 添加主类别 end -->

      <el-tab-pane label="修改" name="second" disabled="disabled">
        <ProjectbomChange ref="SubVuesecond" v-on:triggerFunc="clickreturn"></ProjectbomChange>
      </el-tab-pane>

    </el-tabs>
    <!-- Tabs end -->
  </div>
</template>

<script>
import TencentyunCosUploadExcel from '@/components/TencentyunCosUploadExcel.vue'
import ProjectbomChange from '@/componentsSubVue/ProjectbomChange.vue'
import RsljigouInternal from '@/components/RsljigouInternal.vue'
import Vue from 'vue'
import axios from 'axios'
import VueAxios from 'vue-axios'
import Qs from 'qs'
Vue.use(VueAxios, axios)

export default {
  components: {
    TencentyunCosUploadExcel,
    ProjectbomChange,
    RsljigouInternal
  },
  name: 'MyProjectbom',
  data () {
    return {
      activeName: 'first',
      selectedPageNo: 1,
      dataList: [],
      dataListnum: 0,
      parentlist: [],
      PaymentAccountList: [],
      // 筛选条件
      keywords: {
        parentid: 0,
        name: '',
        bomsn: ''
      },
      // 添加
      addData: {
        parentid: 0,
        bomsn: '',
        name: '',
        specifications: '',
        num: '1'
      },
      addDataMain: {
        jigouid: '0',
        jigouname: '',
        paymentaccountid: 1,
        bomsn: '',
        name: '',
        specifications: ''
      },
      SubRule_MadeManagement_AddProjectbom: false,
      SubRule_MadeManagement_AddProjectbomMain: false,
      SubRule_MadeManagement_DelProjectbom: false,
      SubRule_MadeManagement_EditProjectbom: false,
      SubRule_MadeManagement_AmountProjectbom: false,
      Totalamount: 0
    }
  },
  mounted () {
    this.apiGetWorkprojectList()
    this.apiGetPaymentAccount()

    var that = this
    Vue.prototype.FunCheckSubRule('SubRule_MadeManagement_AddProjectbom', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MadeManagement_AddProjectbom = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MadeManagement_AddProjectbomMain', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MadeManagement_AddProjectbomMain = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MadeManagement_DelProjectbom', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MadeManagement_DelProjectbom = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MadeManagement_EditProjectbom', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MadeManagement_EditProjectbom = true
      }
    })
    Vue.prototype.FunCheckSubRule('SubRule_MadeManagement_AmountProjectbom', function (response) {
      if (response.data.Code === 200) {
        that.SubRule_MadeManagement_AmountProjectbom = true
      }
    })
  },
  methods: {
    changeTencentyunCosUploadExcel (url) {
      this.apiExcelImportProjectbom(url)
    },
    changeRsljigouInternal (vid, vname) {
      this.addDataMain.jigouid = vid
      this.addDataMain.jigouname = vname
    },
    clickreturn () {
      this.activeName = 'first'
      this.apiProjectbomnum()
      this.apiProjectbomlist()
    },
    clickmuban () {
      window.open('https://erp-1256233047.cos.ap-shanghai.myqcloud.com/muban/%E6%89%B9%E9%87%8F%E5%AF%BC%E5%85%A5%E6%A8%A1%E6%9D%BFBom.xlsx')
    },
    handleCurrentPageChange (selectedPageNo) {
      this.apiProjectbomlist()
    },
    clicksearch () {
      this.selectedPageNo = 1
      this.apiProjectbomnum()
      this.apiProjectbomlist()
    },
    clickadd () {
      this.apiAddProjectbom()
    },
    clickaddmain () {
      this.apiAddProjectbomMain()
    },
    clickexcel () {
      this.apiExcelProjectbom()
    },
    clickdelete (row) {
      this.$confirm('是否删除此Bom?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.apiDelProjectbom(row)
      })
    },
    clickedit (row) {
      this.activeName = 'second'
      this.$refs.SubVuesecond.LoadData(row, this.parentlist, this.SubRule_MadeManagement_AmountProjectbom)
    },
    apiProjectbomlist: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        pageno: that.selectedPageNo,
        parentid: that.keywords.parentid,
        name: that.keywords.name,
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Projectbomlist, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataList = response.data.List
            that.Totalamount = Vue.prototype.FunGet2DecimalPlaces(response.data.Totalamount)
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiProjectbomnum: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: that.keywords.parentid,
        name: that.keywords.name,
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_Projectbomnum, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.dataListnum = response.data.Num
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddProjectbom: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: that.addData.parentid,
        bomsn: that.addData.bomsn,
        name: that.addData.name,
        specifications: that.addData.specifications,
        num: that.addData.num,
        price: '0',
        amount: '0'
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddProjectbom, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addData.parentid = 14
            that.addData.bomsn = ''
            that.addData.name = ''
            that.addData.specifications = ''
            that.addData.num = '1'

            that.apiProjectbomnum()
            that.apiProjectbomlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiAddProjectbomMain: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        jigouid: that.addDataMain.jigouid,
        paymentaccountid: that.addDataMain.paymentaccountid,
        bomsn: that.addDataMain.bomsn,
        name: that.addDataMain.name,
        specifications: that.addDataMain.specifications
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_AddProjectbomMain, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.activeName = 'first'

            that.addDataMain.jigouid = '0'
            that.addDataMain.paymentaccountid = 1
            that.addDataMain.bomsn = ''
            that.addDataMain.name = ''
            that.addDataMain.specifications = ''

            that.apiGetWorkprojectList()
            that.apiProjectbomnum()
            that.apiProjectbomlist()
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiDelProjectbom: function (row) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        bomsn: row.Bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_DelProjectbom, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.apiProjectbomnum()
            that.apiProjectbomlist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetWorkprojectList: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        querytype: 1
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetWorkprojectList, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.parentlist = []
            response.data.List.filter((item1, i1) => {
              if (item1.Bomtype > 0) {
                that.parentlist.push({ value: item1.Id, label: item1.Name })
              }
            })
            that.keywords.parentid = that.parentlist[0].value
            that.addData.parentid = that.parentlist[0].value
            that.apiProjectbomnum()
            that.apiProjectbomlist()
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiGetPaymentAccount: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint()
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_GetPaymentAccount, Qs.stringify(data))
        .then(function (response) {
          if (response.data.Code === 200) {
            that.PaymentAccountList = response.data.List
          }
          Vue.prototype.FunCheckApiCodeBackground(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelImportProjectbom: function (url) {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: that.keywords.parentid,
        fileurl: url
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelImportProjectbom, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCode(response.data)
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    },
    apiExcelProjectbom: function () {
      var that = this
      var useriderp = localStorage.getItem('Useriderp')
      var timestamp = Date.parse(new Date()) / 1000
      var data = {
        os: 'erp',
        useriderp: useriderp,
        timestamp: timestamp,
        localfingerprint: Vue.prototype.FunGetLocalFingerprint(),
        parentid: that.keywords.parentid,
        name: that.keywords.name,
        bomsn: that.keywords.bomsn
      }
      // 加上签名
      data.sign = Vue.prototype.FunGetSignErp(data)
      axios.post(Vue.prototype.global.Url_ExcelProjectbom, Qs.stringify(data))
        .then(function (response) {
          Vue.prototype.FunCheckApiCodeWithCallback(response.data, true, function () {
            that.$confirm('是否跳转到文件管理，查看导出情况?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              showCancelButton: true,
              type: 'warning'
            }).then(() => {
              that.$router.push({ path: '/FileManagementExcel' })
            })
          })
        })
        .catch(function (error) {
          Vue.prototype.FunLogError(error)
        })
    }
  }
}
</script>

<style lang="less" scoped>

  .item {
    margin-top: 10px;
    margin-right: 40px;
  }

/deep/ .el-button--mini, .el-button--mini.is-round {
    padding: auto 5px;
}
.select{
   width: 202px;
}

.optometry {
    margin-top: 15px;
    padding: 20px;
    background: #FAFAFA;
    border: 1px solid #EBEEF5;

    & ul{
        flex-wrap: wrap;
        margin: 0;
        padding: 0;

        & li{
            width: 35%;
            line-height: 28px;
            color: #606266;
            list-style: none;
        }
    }
}
.mt20{
   margin-top: 20px;
}

.box-cardprimary{
    margin-top: 0px;
    background: #409eff;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-cardwarning{
    margin-top: 0px;
    background: #ebb562;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.box-carddanger{
    margin-top: 0px;
    background: #f56c6c;
    border: none;
    -webkit-box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
    box-shadow: 0 2px 16px 0 rgba(0, 0, 0, 0.05), 0 0 0px 0 rgba(0,0,0,0);
}

.userList{
    display: flex;
    align-items: center;
    .user{
        color:#ffffff;
        margin: 0 20px 0 0;
    }
    .number{
        font-size: 30px;
        margin: 0;
        font-weight: bold;
        color:#ffffff;
    }
}
</style>
